import { Key } from "./Key";
import CryptoJS from 'crypto-js';

const storeAuth = (val) => {
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(val), Key).toString();
    localStorage.setItem("doctoraUP", ciphertext)
}
const getAuth = () => {
    try {
        let data;
        data = localStorage.getItem("doctoraUP")
        var bytes = CryptoJS.AES.decrypt(data, Key);
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData
    }
    catch {
        return null
    }
}
const clearAuth = () => {
    localStorage.removeItem("doctoraUP")
}

export { storeAuth, getAuth, clearAuth }